import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function CategorySection() {
  return (
    <section className="w-full py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900 mb-2">
            探索视频分类
          </h2>
          <p className="text-sm text-foreground-600">
            十大分类，满足你所有的观影需求
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-xl aspect-[4/3] cursor-pointer"
            >
              <div
                className={`absolute inset-0 bg-gradient-to-br ${cat.color}`}
              />
              <div className="absolute inset-0 bg-black/10 group-hover:bg-black/5 transition-colors" />
              <div className="absolute inset-0 flex flex-col items-center justify-center p-4">
                <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-white/25 backdrop-blur-sm mb-2">
                  <i className="ri-play-circle-fill text-white text-xl md:text-2xl"></i>
                </div>
                <span className="text-white font-semibold text-sm md:text-base whitespace-nowrap">
                  {cat.name}
                </span>
                <span className="text-white/70 text-xs mt-1 text-center leading-tight hidden sm:block">
                  {cat.description}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}